import {FC} from 'react';
import {
	buildMyTaxNameMismatchDescription,
	MY_TAX_NAME_MISMATCH_TITLE,
	MyTaxNameMismatchInfo,
} from '../../model';
import {NameMismatchPuzzleIcon} from 'shared/assets/icons';
import {StepLayout} from 'features/registration';
import styles from './MyTaxNameMismatchStep.module.css';

type Props = {
	mismatch: MyTaxNameMismatchInfo;
};

export const MyTaxNameMismatchStep: FC<Props> = ({mismatch}) => {
	return (
		<StepLayout variant="fill">
			<StepLayout.Intro
				title={MY_TAX_NAME_MISMATCH_TITLE}
				subtitle={
					<span className={styles.description}>{buildMyTaxNameMismatchDescription(mismatch)}</span>
				}
			/>

			<StepLayout.Content className={styles.illustration}>
				<NameMismatchPuzzleIcon className={styles.illustrationIcon} />
			</StepLayout.Content>
		</StepLayout>
	);
};
